


































import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class ConfirmationComponent extends Vue {
  @Prop({
    type: Boolean,
    required: true,
  })
  readonly showConfirmationBox!: boolean;

  @Prop({
    type: String,
    required: true,
  })
  readonly confirmMessage!: string;

  @Emit("allowAction")
  allowAction() {
    // return false to close the confirmation component
    return false;
  }

  @Emit("denyAction")
  denyAction() {
    // return false to close the confirmation component
    return false;
  }
}
